document.addEventListener("DOMContentLoaded", function() {
    setCommentEvents();
})

function setCommentEvents() {
  let currentlyOpenDropdown = null;

  document.querySelectorAll(".moredetailicon").forEach((moredetailicon) => {
    let popupMenumoreDetailsdrop = moredetailicon.nextElementSibling;

    moredetailicon.addEventListener("click", (event) => {
      event.stopPropagation();

      if (popupMenumoreDetailsdrop === currentlyOpenDropdown) {
        hideDropdownAnimated(popupMenumoreDetailsdrop);
        currentlyOpenDropdown = null;
      } else {
        if (currentlyOpenDropdown) {
          hideDropdownAnimated(currentlyOpenDropdown);
        }

        showDropdownAnimated(popupMenumoreDetailsdrop);
        currentlyOpenDropdown = popupMenumoreDetailsdrop;
      }
    });
  });

  document.addEventListener("click", (event) => {
    if (
      currentlyOpenDropdown &&
      !currentlyOpenDropdown.previousElementSibling.contains(event.target) &&
      !currentlyOpenDropdown.contains(event.target)
    ) {
      hideDropdownAnimated(currentlyOpenDropdown);
      currentlyOpenDropdown = null;
    }
  });

  let comments = document.querySelectorAll(".open-reply");
  let currentEditors = {};
  let id, user_image, path, quote, name;

  comments.forEach((comment) => {
    if (!comment.hasAttribute('data-listener-added')) {
      comment.setAttribute('data-listener-added', 'true'); // Mar
      comment.addEventListener("click", function (event) {
        let id = this.getAttribute("data-id");
        let user_image = this.getAttribute("data-img");
        let path = this.getAttribute("data-path");
        let quote = this.getAttribute("data-quote");
        let name = this.getAttribute("data-name");
        let editor = this.closest(`#post_${id}_new`).querySelector(`.redactor-editor-${id}`);

        Object.keys(currentEditors).forEach((editorId) => {
          if (editorId !== id) {
            let otherEditor = currentEditors[editorId];
            if (otherEditor.classList.contains("opened")) {
              slideUpContent(otherEditor);
              setTimeout(() => {
                otherEditor.style.minHeight = "";
                otherEditor.classList.remove("opened");
                otherEditor.innerHTML = "";
                delete currentEditors[editorId];
              }, 300);
            }
          }
        });

        if (editor) {
          // to close already open editors
          if (currentEditors[id] && currentEditors[id] !== editor && currentEditors[id].classList.contains("opened")) {
            currentEditors[id].style.minHeight = "";
            currentEditors[id].classList.remove("opened");
            currentEditors[id].innerHTML = "";
          }
          // For relevant editor
          if (editor.classList.contains("opened")) {
            editor.classList.remove("opened");
            slideUpContent(editor);
            setTimeout(() => {
              editor.innerHTML = "";
              delete currentEditors[id];
            }, 300);
          } else {
            editor.innerHTML = addRedactorEditor(path, user_image, id, quote, name);
            setRedactorReply();
            emojiUnwrapper();
            slideDownContent(editor);
            editor.classList.add("opened");
            currentEditors[id] = editor;
            setTimeout(() => {
              let redactorContentEditable = editor.querySelector('.custom-redactor-reply');
              if (redactorContentEditable && redactorContentEditable.getAttribute('contenteditable') === "true") {
                redactorContentEditable.focus();
              }
            }, 50);
          }
        }
      });
    }
  });

  let reply_box_elements = document.querySelectorAll(".reply-box-open-close");
  reply_box_elements.forEach((reply_box) => {
    let closed_box = reply_box.querySelector(".reply-box-closed");
    if (reply_box) {
      reply_box.addEventListener("click", function (event) {
        let box_closed = closed_box.classList.contains("hidden");
        if (box_closed) return;
        let id = this.getAttribute("data-id");
        let user_image = this.getAttribute("data-img");
        let path = this.getAttribute("data-path");
        let name = this.getAttribute("data-name");
        let closed_content = reply_box.querySelector(`.reply-box-closed`);
        let reply_box_post = reply_box.querySelector(`.reply-box-post`);
        closed_content.classList.add("hidden");
        reply_box_post.classList.remove("hidden");
        this.classList.remove("p-3");
        reply_box_post.innerHTML = addRedactorEditor(
          path,
          user_image,
          id,
          "",
          name
        );
        setRedactorReply();
        emojiUnwrapper();
        // setEmptyCommentFilter();
        // addLoaderForComments();
        setTimeout(() => {
          let redactorContentEditable = reply_box_post.querySelector(
            ".custom-redactor-reply"
          );
          if (
            redactorContentEditable &&
            redactorContentEditable.getAttribute("contenteditable") === "true"
          ) {
            redactorContentEditable.focus();
          }
        }, 50);
      });
    }
  });

  setCommentActionsEvents();
  userProfileActionEvents();
}

// below is possible solution for emoji image edit problem - DO NOT REMOVE

function emojiUnwrapper() {
  document
    .querySelectorAll("figure")
    .forEach((figure) => {
      let image = figure.querySelector("img.editor-emojiImg");
      if (image) {
        // Add contenteditable="false" to the image inside the figure
        image.setAttribute("contenteditable", "false");

        // Remove the class from the figure tag
        figure.removeAttribute("class");
      }
    });
}


function hasContent(htmlString) {
  let cleanedString = htmlString.replace(/<(\w+)[^>]*>\s*<\/\1>/g, "");
  if (cleanedString.includes('<img')) {
    return true;
  }
  let strippedString = cleanedString.replace(/<\/?[^>]+(>|$)/g, "").trim();
  return strippedString.length > 0;
}

function escapeHtml(unsafe) {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function addRedactorEditor(path, user_image, id, quote, name) {
  let escapedQuote = escapeHtml(quote);
  let editorContent = `
    <form class="relative" action="${path}" method="post" data-remote="true" onsubmit="disableForm(event, this)">
      <div class="redactor-user-profile">
        <img src="${user_image}" alt="${name}" loading="lazy" class="redactor-user-profile-pic" />
      </div>
      <textarea name="${name}" class="redactor-textarea"></textarea>
      ${
        id
          ? `<input type="hidden" name="post[parent_post_id]" value="${id}" />`
          : ""
      }
      ${
        escapedQuote
          ? `<input type="hidden" name="post[quote]" value="${escapedQuote}" />`
          : ""
      }
      <button type="submit" class="redactor-submit-button px-5 gtm_submit_reply_deal_details">
        <div class="inline-flex justify-center items-center redactor-submit-button-text w-max transition-all duration-300">
          ${I18n.t("reply")}
          <svg class="ml-2" xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 31.533 26.554">
            <path id="send" d="M120-773.446V-783.4l13.277-3.319L120-790.042V-800l31.533,13.277Z" transform="translate(-120 800)" fill="#FFFFFF"/>
          </svg>
        </div>
        <div class="hidden absolute comment-loader inset-0 flex justify-center items-center">
          <div class="w-6 h-6 border-4 border-t-transparent border-white border-solid rounded-full animate-spin"></div>
        </div>
      </button>
    </form>
  `;
  return editorContent;
}

function disableForm(event, form) {
  // Check for empty or whitespace content
  const content = form.querySelector("textarea.redactor-textarea");

  if (content) {
    const htmlContent = content.value || content.innerHTML;
    if (!hasContent(htmlContent)) {
      // Prevent form submission and stop other event handlers
      event.preventDefault();
      event.stopImmediatePropagation();
      showToast(I18n.t("empty_comment_error"));
      return false; // Stop submission
    }
  }

  // Disable all form inputs
  const inputs = form.querySelectorAll("input, textarea, button");
  inputs.forEach((input) => input.classList.add("pointer-events-none"));

  // Declare variables for the submit button, button text, and loader
  const submitButton = form.querySelector(".redactor-submit-button");
  let buttonText, loader;

  if (submitButton) {
    buttonText = submitButton.querySelector(".redactor-submit-button-text");
    loader = submitButton.querySelector(".comment-loader");

    // Show loader and hide the submit button text
    if (buttonText && loader) {
      buttonText.classList.add("hidden");
      loader.classList.remove("hidden");
    }
  }

  // Re-enable inputs after a timeout (optional)
  setTimeout(() => {
    inputs.forEach((input) => input.classList.remove("pointer-events-none"));

    // Reset the button loader state after timeout
    if (buttonText && loader) {
      buttonText.classList.remove("hidden"); // Show the text again
      loader.classList.add("hidden"); // Hide the loader
    }
  }, 5000); // 10 seconds timeout
}

window.disableForm = disableForm;
window.emojiUnwrapper = emojiUnwrapper;
window.setCommentEvents = setCommentEvents;